import React from 'react';
import classes from './team.module.css';
import Title from "../../containers/title/title";
import StaffMember from '../../containers/staffMember/staffMember';

const Team = ({team}) => {
    return (
        <div className={classes.Container}>
            <Title title={team.title} />
            <div className={classes.staffGrid}>
                {team?.members?.map((member, index) => (
                    <StaffMember key={index} {...member} />
                ))}
            </div>
        </div>
    )
}
export default Team;